import styled from 'styled-components';

export const GridTale = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => theme.mediaQueries.small} {
    grid-column: span 4;
  }
  ${({ theme }) => theme.mediaQueries.medium} {
    grid-column: span 4;
  }
  ${({ theme }) => theme.mediaQueries.large} {
    grid-column: span 4;
  }
  ${({ theme }) => theme.mediaQueries.xLarge} {
    grid-column: span 3;
  }
`;

export const GridFullRow = styled.div`
  grid-column: 1 / -1;
`;

export const GridRelay = styled.div<{ grid?: boolean }>`
  display: ${({ grid = true }) => `${grid ? 'contents' : 'block'}`};
`;
